import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// Emite el certificado. El backend lo genera, lo guarda en el expediente del
// empleado y devuelve la URL temporal de descarga, así que el operario puede
// volver a bajarlo desde su portal.
export const generarCertificadoLaboral = async (payload) => {
  const { data } = await axios.post(
    `${API_URL}/personal/documentos/certificado-laboral`,
    payload,
  );
  return data;
};

export const listarCertificados = async (limite = 50) => {
  const { data } = await axios.get(
    `${API_URL}/personal/documentos/certificados`,
    { params: { limite } },
  );
  return data;
};